export const initializeMap = (mapElement: HTMLElement, center: { lat: number; lng: number }, zoom: number): google.maps.Map => {
  return new google.maps.Map(mapElement, {
    center,
    zoom,
    mapId: 'default',
    mapTypeId: 'roadmap',
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false,
  });
};

export const addMarker = (map: google.maps.Map, position: google.maps.LatLng): google.maps.marker.AdvancedMarkerElement => {
  const marker = new google.maps.marker.AdvancedMarkerElement({
    map,
    position,
  });
  return marker;
};

export const setupAutocomplete = (map: google.maps.Map, input: HTMLInputElement, onPlaceChanged: (place: google.maps.places.PlaceResult) => void) => {
  const autocomplete = new google.maps.places.Autocomplete(input, {
    fields: ['geometry', 'address_components', 'formatted_address'], // Ensures relevant data is returned
    types: ['address'],  // Filters to only show addresses
    componentRestrictions: { country: 'us' } // Optionally restrict to a country
  });

  autocomplete.bindTo('bounds', map);  // This ensures autocomplete respects map boundaries

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();
    if (place.geometry && place.geometry.location) {
      onPlaceChanged(place);  // Invokes the callback when a place is selected
    } else {
      console.error('Place has no geometry');
    }
  });
};


export const calculateRoute = (
  directionsService: google.maps.DirectionsService,
  directionsRenderer: google.maps.DirectionsRenderer,
  origin: google.maps.LatLng,
  destination: google.maps.LatLng
) => {
  return new Promise<google.maps.DirectionsResult>((resolve) => {
    directionsService.route(
      {
        origin,
        destination,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK && result) {
          directionsRenderer.setDirections(result);
          resolve(result);
        } else {
          console.error('Directions request failed due to ' + status);
        }
      }
    );
  })
};